import axiosInstance from 'plugins/axios';
import { IQuestionNewEditForm } from 'types/campaign-design';
import { IBodyResponse } from 'types/type.global';
export interface IQuestionPage {
    id: string;
    type: string;
    attributes: {
        id: number;
        survey_id: number;
        title: string;
        page_number: number | null;
        created_at: string;
        updated_at: string;
        questions: IQuestionNewEditForm[];
    };
}

export interface IQuestionPagesResponse {
    question_pages: IQuestionPage[];
}

export const listQuestionsPageLogic = async (
    campaignId: number
): Promise<IBodyResponse<IQuestionPagesResponse>> => {
    const response = await axiosInstance.get(
        `admin/question_pages?survey_id=${campaignId}`
    );
    return response.data;
};
export const createPageLogic = async (
    campaignId: number,
    title: string
): Promise<IBodyResponse<{ question_page: IQuestionPage }>> => {
    const response = await axiosInstance.post(`admin/question_pages`, {
        question_page: {
            survey_id: campaignId,
            title: title,
        },
    });
    return response.data;
};

export const deletePageLogic = async (
    pageId: string
): Promise<IBodyResponse<null>> => {
    const response = await axiosInstance.delete(
        `admin/question_pages/${pageId}`
    );
    return response.data;
};

export const updatePageLogic = async (
    survey_id: number,
    pageId: string,
    title: string
): Promise<IBodyResponse<{ question_page: IQuestionPage }>> => {
    const response = await axiosInstance.put(`admin/question_pages/${pageId}`, {
        question_page: {
            title: title,
            survey_id: survey_id,
        },
    });
    return response.data;
};
